import CommonAppbar from '../components/common/CommonAppbar';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import CategoryIcon from '@mui/icons-material/Category';
import PersonIcon from '@mui/icons-material/Person';
import {faker} from '@faker-js/faker';
import {useNavigate} from 'react-router-dom';
import {getFilteredPollsLink} from '../utils/helper';
import {FILTERED_POLLS_TYPES, URLS} from '../constants/appConstants';
import CreateFAB from '../components/common/CreateFAB';

const getRandomNumber = () => {
  return faker.number.int({min: 10, max: 400})
}

const buttonStyles = {
  common: {
    height: 80
  }
}
export default function Activities() {
  const navigate = useNavigate();
  const handleFilterClick = (filterId) => {
    navigate(getFilteredPollsLink(filterId));
  }

  return <>
    <CommonAppbar isMainPage={true} pageHeader={'Activities'}/>
    <Box sx={{ml: 1, mr: 1, mt: 2}}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Button variant="contained"
                  sx={buttonStyles.common}
                  startIcon={<AddIcon/>}
                  onClick={() => navigate(URLS.SELECT_QUESTION_TYPE)}
                  fullWidth>
            Create
          </Button>
        </Grid>

        <Grid item xs={12}>
          <Button variant="contained"
                  color="secondary"
                  sx={buttonStyles.common}
                  startIcon={<CategoryIcon/>}
                  fullWidth
                  onClick={() => navigate(URLS.CATEGORY)}
          >
            My Interests
          </Button>
        </Grid>

        <>
          {Object.entries(FILTERED_POLLS_TYPES).map(([filteredPollKey, filteredPollValue]) => {
            return <Grid item xs={6}>
              <Button variant="outlined" startIcon={<PersonIcon/>}
                      sx={buttonStyles.common}
                      onClick={() => handleFilterClick(filteredPollValue)}
                      fullWidth>
                {filteredPollValue}({getRandomNumber()})
              </Button>
            </Grid>
          })}
        </>
      </Grid>
    </Box>
    <CreateFAB/>

  </>
}
